import { NavigateFunction } from "react-router-dom";
import { NFT, Voucher } from "./nfts.reducer";


export const NFT_ACTION_FAILED = '[NFT] NFT action failed';

// API Actions
export const GET_WALLET_TOKENS = '[NFT] Get wallet tokens';
export const GET_WALLET_TOKENS_SUCCESS = '[NFT] Get wallet tokens success';

export const GET_LISTED_VOUCHERS = '[NFT] Get listed vouchers';
export const GET_LISTED_VOUCHERS_SUCCESS = '[NFT] Get listed vouchers success';

export const LAZY_MINT = '[NFT] Lazy mint';
export const LAZY_MINT_SUCCESS = '[NFT] Lazy mint success';

export const SLOT_CLICKED = '[NFT] Slot clicked'; // selected NFT, not API

export const LIST_NFT = '[NFT] Nft list';
export const LIST_NFT_SUCCESS = '[NFT] Nft list success';

export const UNLIST_NFT = '[NFT] Unlist NFT';
export const UNLIST_NFT_SUCCESS = '[NFT] Unlist NFT success';


export const BUY_NFT = '[NFT] Nft buy';
export const BUY_NFT_SUCCESS = '[NFT] Nft buy success';

export const RESELL = '[NFT] Resell NFT';
export const RESELL_SUCCESS = '[NFT] Resell NFT success';

// Non-API actions
export const DROPPED_NFT = '[NFT] Dropped NFT';

export const GetVouchers = (payload?: string) => {
    return {
        type: GET_LISTED_VOUCHERS,
        payload
    }
}

export const GetVouchersSuccess = (payload: Voucher[]) => {
    return {
        type: GET_LISTED_VOUCHERS_SUCCESS,
        payload
    }
}

export const GetWalletTokens = (payload: string) => {
    return {
        type: GET_WALLET_TOKENS,
        payload
    }
}

export const GetWalletTokensSuccess = (payload: Voucher[] | NFT[]) => {
    return {
        type: GET_WALLET_TOKENS_SUCCESS,
        payload
    }
}

export const LazyMint = (payload: Voucher) => {
    return {
        type: LAZY_MINT,
        payload
    }
}

export const LazyMintSuccess = (payload: any) => {
    return {
        type: LAZY_MINT_SUCCESS,
        payload
    }
}

export const NftActionFailed = (payload: string) => {
    return {
        type: NFT_ACTION_FAILED,
        payload
    }
}

/**
 * Assume called in main3d class. pass slot position and token id
 * @param payload slot position and token id
 * @returns state
 */
export const SlotClicked = (payload: {
    slot: string, // could be space name + slot name.....
    selectedNFT: Voucher
}) => {
    return {
        type: SLOT_CLICKED,
        payload
    }
}

export const NftDropped = (payload: NFT) => {
    return {
        type: DROPPED_NFT,
        payload
    }
}

/**
 * This action is happened when artist click list button after drag drop.
 * @param payload voucher id(string), slot position(string)
 * @returns call list nft success action if success
 */
export const ListNFT = () => {
    return {
        type: LIST_NFT
    }
}

/**
 * It is called when list nft action is success
 * @param payload status
 * @returns update wallet tokens and art works
 */
export const ListNFTSuccess = (payload: any) => {
    return {
        type: LIST_NFT_SUCCESS,
        payload
    }
}

export const UnlistNFT = () => {
    return {
        type: UNLIST_NFT
    }
}

export const UnlistNFTSuccess = (payload: any) => {
    return {
        type: UNLIST_NFT_SUCCESS,
        payload
    }
}

export const BuyNFT = (payload: {
    newOwner: string,
    hash: string
}) => {
    return {
        type: BUY_NFT,
        payload
    }
}

export const BuyNFTSuccess = (payload: any) => {
    return {
        type: BUY_NFT_SUCCESS,
        payload
    }
}

export const ResellNFT = (payload: Voucher) => {
    return {
        type: RESELL,
        payload
    }
}

export const ResellNFTSuccess = (payload: Voucher) => {
    return {
        type: RESELL_SUCCESS,
        payload
    }
}